<template>
  <div>
    <div
      @click="jumpUrl(`/org/${orgId}`)"
      class="footer-org-info"
      :class="{
        'electron-footer-org': isElectron,
        'h5-footer-org': isH5,
        'pc-footer-org': !isH5,
      }"
    >
      <img
        v-if="orgInfo.org_logo"
        class="logo"
        :src="orgInfo.org_logo + '?imageView2/0/w/100'"
        alt="logo"
      />
      <img
        v-else
        class="logo"
        src="https://cdn.comettech.com/cdn/static/images/default_org_logo.png?imageView2/0/w/100"
        alt="logo"
      />
      <p v-if="showOrgName" class="org-name">
        {{ orgInfo.org_name }}
      </p>
    </div>
  </div>
</template>

<script>
import { isH5, isMobile } from "@saas/components/src";
export default {
  props: {
    orgInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orgId: {
      type: String,
      default: "",
    },
    showOrgName: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isMobile: isMobile(),
      isH5: isH5(),
      inIosReview: false,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  methods: {
    jumpUrl(url) {
      if (this.inIosReview) {
        url = `${url}?inReview=1`;
      }
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-footer-org {
  cursor: pointer;
  display: flex;
  align-items: center;
  .logo {
    width: 38px;
    height: 38px;
    border-radius: 19px;
    border: 1px solid #e2e2e2;
    object-fit: cover;
    margin-right: 8px;
  }
  .org-name {
    max-width: 182px;
    font-weight: 500;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
.h5-footer-org {
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    width: 0.93rem;
    height: 0.93rem;
    border-radius: 0.51rem;
    border: 0.03rem solid #e2e2e2;
    object-fit: cover;
  }
  .org-name {
    margin-top: 0.11rem;
    max-width: 2.05rem;
    font-weight: 500;
    font-size: 0.29rem;
    color: #515350;
    line-height: 0.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
.electron-footer-org.footer-org-info {
  .logo {
    width: 30px;
    height: 30px;
  }
}
</style>
